.theme {
  --asset-accent: #0891b2;
  --asset-dark: #0e7490;
  --asset-deep: #164e63;
  --asset-soft: #ecfeff;
  --asset-pale: #cffafe;
  --asset-border: #a5f3fc;
  --asset-border-strong: #67e8f9;
  --asset-shadow-rgb: 8 145 178;
}
